import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import axiosInstance from "../../../configs/axios/axios ";
import {
  SHAREMANAGEMENT_LIST,
  DELETE_SHAREMANAGEMENT_LIST,
  UPDATE_SHAREMANAGEMENT_COUNT,
} from "../../../configs/axios/constantsAPI";
import { getCookie } from "../../../configs/cookie-helper/cookieHelper";

export const getShareManagementListAction = createAsyncThunk(
  "shareManagement/getshareManagementList",
  async (sendData: any, { rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        SHAREMANAGEMENT_LIST,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );
      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteShareManagementListAction = createAsyncThunk(
  "shareManagement/deleteshareManagementList",
  async (sendData: any, { dispatch, rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        DELETE_SHAREMANAGEMENT_LIST,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      dispatch(
        getShareManagementListAction({
          file_id: getState().directoryItemsState.itemInfo.id,
        })
      );
      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateShareManagementCountAction = createAsyncThunk(
  "shareManagement/updateShareManagementCount",
  async (sendData: any, { dispatch, rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        UPDATE_SHAREMANAGEMENT_COUNT,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      dispatch(
        getShareManagementListAction({
          file_id: getState().directoryItemsState.itemInfo.id,
        })
      );
      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export interface Items {
  name: string;
  alternative: null | string;
  description: string;
  download: number;
  number_download: string;
  password: boolean;
  id: string;
  uniq_id: string;
  link: string;
}

export interface ShareManagementState {
  shareManagementData: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
    list: Array<Items>;
  };

  updateShareManagementCount: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
  };
}

const initialState: ShareManagementState = {
  shareManagementData: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
    list: [],
  },

  updateShareManagementCount: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
  },
};

export const shareManagementSlice = createSlice({
  name: "shareManagement",
  initialState,
  reducers: {},
  extraReducers: ({ addCase }) => {
    addCase(getShareManagementListAction.pending, (state) => {
      state.shareManagementData.actionStatus = "loading";
      state.shareManagementData.alert = {
        error: false,
        message: "",
      };
    });
    addCase(getShareManagementListAction.fulfilled, (state, { payload }) => {
      state.shareManagementData.actionStatus = "success";
      state.shareManagementData.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
      state.shareManagementData.list = payload.content?.data;
    });
    addCase(
      getShareManagementListAction.rejected,
      (state, { payload }: any) => {
        state.shareManagementData.actionStatus = "rejected";
        state.shareManagementData.alert = {
          error: payload.content?.error,
          message: payload.content?.error
            ? "Sorry, we encountered an error!"
            : "Great, we didn't encounter any errors!",
        };
      }
    );

    addCase(updateShareManagementCountAction.pending, (state) => {
      state.updateShareManagementCount.actionStatus = "loading";
      state.updateShareManagementCount.alert = {
        error: false,
        message: "",
      };
    });
    addCase(
      updateShareManagementCountAction.fulfilled,
      (state, { payload }) => {
        state.updateShareManagementCount.actionStatus = "success";
        state.updateShareManagementCount.alert = {
          error: payload.content?.error,
          message: payload.content?.error
            ? payload.content?.message === "login_again"
              ? "login_again"
              : payload.content?.message
            : "Great, we didn't encounter any errors!",
        };
      }
    );
    addCase(
      updateShareManagementCountAction.rejected,
      (state, { payload }: any) => {
        state.updateShareManagementCount.actionStatus = "rejected";
        state.updateShareManagementCount.alert = {
          error: payload.content?.error,
          message: payload.content?.error
            ? "Sorry, we encountered an error!"
            : "Great, we didn't encounter any errors!",
        };
      }
    );
  },
});

export const shareManagement = (state: RootState) => state.shareManagementState;

export default shareManagementSlice.reducer;
